<template>
  <div class="expandableList">
    <div v-for="(list, index) in data" :key="index" class="expandableList__card">
      <div class="expandableList__card__header">
        <div class="expandableList__card__header__top">
          <div class="expandableList__card__header__top__place-image">
            <img v-if="list.primary_photo" :src="list.primary_photo">
            <img v-else :src="`/img/notfound/img-placeholder_landscape.jpg`" alt="">
          </div>
          <div class="expandableList__card__header__top__info" @click="goToParentDetail(list)">
            <div class="expandableList__card__header__top__info__header">
            <span :class="['category small-font strong', 
              {'spbu': list.category_display === 'spbu',
              'lifestyle': list.category_display === 'lifestyle',
              'mall': list.category_display === 'malls',
              'airport': list.category_display === 'airport',
              'airlines': list.category_display === 'airlines'}]">
              {{category_display(list.category_display) | capitalize}}
            </span>
            <adx-label-custom v-if="list.class && list.class === 'PR'" class="premium" :color="'#ceb521'" :type="'premium'" :label="'Premium'"/>
            </div>
            <span class="strong title">{{list.title}}</span>
            <span class="color-grey type">{{list.property_type_display}} • {{list.cluster_name}}</span>
            <span class="address">{{list.street}}</span>
            <span> <b>Traffic</b> {{list.traffic * 30 | formatNumber }} monthly visitor</span>
          </div>
        </div>
        <div class="expandableList__card__header__bot" @click="toggleOpen(index)">
          <span class="available color-pink" v-if="list.media.length > 1">{{list.media.length}} Available Advertisements</span>
          <span class="available color-pink" v-else>{{list.media.length}} Available Advertisement</span>
          <div class="expand">
            <i v-if="isOpen[index]" class="icon-chevronup color-pink"></i> 
            <i v-else class="icon-chevrondown color-pink"></i>
          </div>
        </div>
      </div>
      <div :class="['expandableList__card__close', isOpen[index] ? 'open' : '']">
        <div v-for="(item, index) in list.media" :key="index" class="expandableList__card__channels">
          <adx-expandable-level2 :item="item"  :addButton="addButton" :list="list" :viewPhoto="viewPhotos"
            @removeFromCampaign="removeFromCampaign"
            @toggleSave="toggleSave"
            @addToCampaign="addToCampaign"
            @goToDetail="goToDetail"
            @previewImage="previewImage"/>
          <!-- <div class="expandableList__card__channels__header">
            <div class="expandableList__card__channels__header__title">
              <span class="strong" @click="goToDetail(item, list)">{{item.placement}} {{media_type(item, list.property_type) | capitalizing}} </span>
            </div>
            <button class="btn-regular secondary" @click.stop="toggleSave(list, item)"> 
              <div class="saved_button">
                <div v-if="item.saved" class="saved_button__is_saved">
                  <i class="icon-check icon"></i>
                  <span> Saved </span>
                </div>
                <div v-else class="saved_button__not_saved">
                  <i class="icon-add icon"></i>
                  <span class="label">Save</span>
                </div>
              </div>
            </button>
          </div>
          <div class="expandableList__card__channels__content">
            <div class="expandableList__card__channels__content__left">
              <div class="expandableList__card__channels__content__left__place-image">
                <img v-if="item.photo" :src="item.photo" alt="">
                <img v-else :src="`/img/notfound/img-placeholder_landscape.jpg`">
              </div>
              <div class="expandableList__card__channels__content__left__info">
                <span> {{item.description}} </span>
                <div class="expandableList__card__channels__content__left__info__left">
                  <span> Total screens <b>3 screens</b> </span>
                  <span> Screen size <b>42 inch</b> </span>
                  <span> Orientation <b>Landsacpe</b> </span>
                </div>
                <div class="expandableList__card__channels__content__left__info__right">
                  <span> Resolution <b>1080p</b> </span>
                  <span> Playback <b>80/day</b> </span>
                </div>
              </div>
            </div>
            <div class="expandableList__card__channels__content__right">
              <div class="expandableList__card__channels__content__right__price">
                <span v-if="item.period" class="small-font">Price per {{item.period}}</span>
                <span v-else class="small-font">Price per day</span>
                <span class="large-font color-pink strong">{{item.price | formatMoney}}</span>
                <span v-if="item.include_tax" class="small-font color-grey">Inclusive of Taxes</span>
                <span v-else class="small-font color-grey">Exclusive of Taxes</span>
              </div>
              <div class="expandableList__card__channels__content__right__button">
                <button class="primary btn-regular" @click="addToCampaign(list, item)">Add To Campaign</button>
              </div>
            </div>
          </div> -->
        </div>
        <div v-if="custom" class=expandableList__card__channels>
          <div class="expandableList__card__channels__header">
            <div class="expandableList__card__channels__header__title">
              <span class="strong">Custom Advertisement</span>
            </div>
            <button class="primary btn-regular" @click="customAdvertisement(list)">Add To Order</button>
          </div>
        </div>
      </div>
    </div>
    <div class="emptyState" v-if="isEmpty && !loading">
      <adx-empty-selection />
    </div>
    <div class="expandableList__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import ExpandableLevel2 from '@/components/ExpandableListItems/Level2'
import LabelStatusCustom from '@/components/StatusLabelCustom'

export default {
  name: 'adx-expandable-listitems',
  components: {
    'adx-expandable-level2' : ExpandableLevel2,
    'adx-label-custom' : LabelStatusCustom
  },
  props: {
    data: {
      required: true
    },
    addButton: {
      required: false
    },
    removeButton: {
      required: false
    },
    custom: {
      required: false,
      default: false
    },
    viewPhotos: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      isEmpty: false,
      isOpen: [],
      isLoading: []
    }
  },
  computed: {
    getVisitor: function() {
      return list.traffic * 30 
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.setIsOpen()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    customAdvertisement(list){
      this.$emit('customAdvertisement', list)
    },
    previewImage(item, list){
      this.$emit('previewImage', item, list)
    },
    toggleSave(list, item) {
      this.$emit('toggleSave',list, item)
    },
    addToCampaign(list, item) {
      this.$emit('addToCampaign',list, item)
    },
    removeFromCampaign(item, list){
      this.$emit('removeFromCampaign', item, list)
    },
    setIsOpen() {
      if(this.data) {this.data.map(() => this.isOpen.push(false))}
    },
    toggleOpen(index) {
      this.$set(this.isOpen, index, !this.isOpen[index])
    },
    goToDetail(item, list) {
      this.$emit('goToDetail',item, list)
    },
    goToParentDetail(list) {
      this.$emit('goToParentDetail', list)
    },
    media_type(item, type){
      if (item.media_name.trim() === 'device'){
        return `digital screen`
      } else if (item.media_name.trim() === 'experience branding'){
        if (type.trim() === 'AM'){
          return `lightbox`
        }
        return `experience branding package`
      } else if (item.media_name.trim() === 'screen'){
        if (type.trim() === 'AM'){
          return `lcd`
        } 
        return `office`
      }
      return item.media_name
    },
    category_display(item){
      if (item.trim() === 'airport') {
        return `airport lounge`
      }
      return item
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>